import { gql } from '@apollo/client';

export const AcceptConsentPolicyMutation = gql`
  mutation acceptConsentPolicy($policyIds: [ID!]!) {
    acceptConsentPolicy(policyIds: $policyIds) {
      id
    }
  }
`;
